<template>
    <div class="show-poster" @click="$emit('click')">
        <lazy-image
            v-if="imageSrc"
            :src="imageSrc"
            :srcset="srcSet"
            :alt="show.name"
            :src-placeholder="placeholder"
            :sizes="srcSizes"
        />
        <div v-else class="image-placeholder" />
    </div>
</template>

<script>
import cl from 'src/util/cloudinary';
import { toSrcSet, mediaQueryWidth } from 'src/util/helpers';

export default {
    props: ['slug', 'width', 'mobileWidth'],
    data() {
        return {
            placeholder: cl.url('grosses/blank', {
                width: this.width,
                height: Math.floor(this.width * 1.533333333),
                fetch_format: 'auto',
                crop: 'scale',
            }),
        };
    },
    computed: {
        show() {
            return this.$store.getters['shows/show'](this.slug);
        },
        imageSrc() {
            if (!this.show) {
                return false;
            }

            if (!this.show.image) {
                return false;
            }

            return this.getImageAtSize(this.width);
        },
        srcSet() {
            return toSrcSet({
                [`${this.width}w`]: this.getImageAtSize(this.width),
                [`${this.width * 2}w`]: this.getImageAtSize(this.width * 2),
                [`${this.mobileWidth}w`]: this.getImageAtSize(this.mobileWidth),
                [`${this.mobileWidth * 2}w`]: this.getImageAtSize(
                    this.mobileWidth * 2,
                ),
            });
        },

        srcSizes() {
            return [
                `${mediaQueryWidth('medium', 'max')} ${this.mobileWidth}px`,
                `${this.width}px`,
            ].join(',');
        },
    },
    methods: {
        getImageAtSize(width) {
            return cl.url(this.show.image, {
                width: width,
                crop: 'scale',
                fetch_format: 'auto',
            });
        },
    },
};
</script>
